import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';

@Component({
  selector: 'app-submit-updated-dialog',
  standalone: true,
  imports: [CommonModule, DialogModule, ButtonModule],
  template: `
    <p-dialog header="Submit Updated Items" [(visible)]="visible" [modal]="true" [closable]="false" [style]="{ width: '30vw' }" [baseZIndex]="10000">
      <p>You have updated items in this order. Would you like to submit them to the insectary team for review?</p>

      <p class="audit-text-small">Failure to submit updates for review may result in delays in processing your order.</p>
      <ng-template pTemplate="footer">
        <button pButton label="No" class="p-button" (click)="onCancel()"></button>
        <button pButton label="Yes (Submit)" class="p-button" severity="success" (click)="onSubmit()"></button>
      </ng-template>
    </p-dialog>
  `
})
export class SubmitUpdatedDialogComponent {
  @Input() visible = false;
  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() decision = new EventEmitter<'submit' | 'cancel'>();

  onSubmit() {
    this.visible = false;
    this.visibleChange.emit(this.visible);
    this.decision.emit('submit');
  }

  onCancel() {
    this.visible = false;
    this.visibleChange.emit(this.visible);
    this.decision.emit('cancel');
  }
}
